module.exports = __webpack_public_path__ + "static/media/9.d6a4b4ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/9.jpg
// module id = 600
// module chunks = 0